export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M23.3 14.716a1.717 1.717 0 100-3.434h-8.583V2.7a1.717 1.717 0 00-3.433 0v8.582H2.7a1.717 1.717 0 000 3.434h8.584v8.583a1.717 1.717 0 103.433 0v-8.583H23.3z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 26 26"
  }
};